import React from 'react'

function ServiceCard(props){
    const {
        title,
        img,
        site,
        enableTransition,
        active,
        className,
        claimed,
        refreshRequired,
        overrideIcon,
        disableHoverStyles,
        alt,
        id
    } = props

    return <div id={id} className={`${className} p-5 border text-center ${disableHoverStyles ? "" : "card-highlight"} ${active ? "border-primary": ""} ${!enableTransition ? "highlight-disable" : ""}`} onClick={() => props.onChosen()}>
        <img style={{width:"50px", height: "50px"}} src={img} class="img-fluid" alt={alt ? alt : ""} title={alt ? alt : ""} /><br />
        {title && <label class={`col-form-label ${active ? "text-primary": ""}`}>
            {title} {overrideIcon ? overrideIcon : refreshRequired ? <i className="fas fa-exclamation-circle text-danger fa-1-5"></i> :
                claimed ? <i class="fas fa-check-circle text-success fa-1-5"></i> : ""}
        </label>}
    </div>
}

ServiceCard.defaultProps = {
    enableTransition: true,
    className: "",
    overrideIcon: null,
    title: null,
    alt: null,
    disableHoverStyles: false,
    id: undefined
}

export default ServiceCard